/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_StudentsInputs */

const en_nav_students = /** @type {(inputs: Nav_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Students`)
};

const he_nav_students = /** @type {(inputs: Nav_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תלמידים`)
};

/**
* | output |
* | --- |
* | "Students" |
*
* @param {Nav_StudentsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const nav_students = /** @type {((inputs?: Nav_StudentsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_StudentsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_students(inputs)
	return he_nav_students(inputs)
});